// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aurora-search-button.MuiButton-root {
  font-family: BrightstarSans-Regular;
  min-width: 140px;
  color: #ffffff;
  background: linear-gradient(90deg, #050a30 0%, #0b1f4d 55%, #143a7b 100%);
  box-shadow:
    0 2px 8px rgba(5, 5, 51, 0.08),
    0 6px 20px rgba(5, 5, 51, 0.07);
}

.aurora-search-button.MuiButton-root:hover {
  background: linear-gradient(90deg, #050a30 0%, #0b1f4d 55%, #143a7b 100%);
  filter: brightness(1.08);
  box-shadow:
    0 4px 12px rgba(5, 5, 51, 0.1),
    0 12px 28px rgba(5, 5, 51, 0.12);
}

.aurora-search-button.MuiButton-root.Mui-disabled {
  color: rgba(255, 255, 255, 0.65);
  background: linear-gradient(90deg, #050a30 0%, #0b1f4d 55%, #143a7b 100%);
  opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/modules/contactCenter/aurora/styles/aurora.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,yEAAyE;EACzE;;mCAEiC;AACnC;;AAEA;EACE,yEAAyE;EACzE,wBAAwB;EACxB;;oCAEkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,yEAAyE;EACzE,YAAY;AACd","sourcesContent":[".aurora-search-button.MuiButton-root {\n  font-family: BrightstarSans-Regular;\n  min-width: 140px;\n  color: #ffffff;\n  background: linear-gradient(90deg, #050a30 0%, #0b1f4d 55%, #143a7b 100%);\n  box-shadow:\n    0 2px 8px rgba(5, 5, 51, 0.08),\n    0 6px 20px rgba(5, 5, 51, 0.07);\n}\n\n.aurora-search-button.MuiButton-root:hover {\n  background: linear-gradient(90deg, #050a30 0%, #0b1f4d 55%, #143a7b 100%);\n  filter: brightness(1.08);\n  box-shadow:\n    0 4px 12px rgba(5, 5, 51, 0.1),\n    0 12px 28px rgba(5, 5, 51, 0.12);\n}\n\n.aurora-search-button.MuiButton-root.Mui-disabled {\n  color: rgba(255, 255, 255, 0.65);\n  background: linear-gradient(90deg, #050a30 0%, #0b1f4d 55%, #143a7b 100%);\n  opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
